<template>
  <div class="container">
    <div class="main">
      <div class="module_section1">
        <h3 class="title">能源物联网平台</h3>
        <p class="cont">提供从硬件开发平台、基础云平台、消息服务平台到场景化开发平台的完整解决方案；为各类能源设备提供安全可靠的设备连接通信能力，支持多协议适配，提供设备管理能力，支持设备模型定义、数据结构化存储和远程调试、监控、运维</p>
        <!-- <a href="javascript:;" class="btn" @click="goToLink('/index?id=applyUse')">
          方案咨询
          <i class="el-icon-right rightIcon1"></i>
        </a> -->
      </div>
      <div class="navs">
        <ul class="module">
          <li 
            v-for="(el, ind) in navs" 
            :key="ind" 
            :class="el.actived ? 'actived' : ''"
            @click="handleChangeNav(ind, 'navs', el)"
            >
              {{el.name}}<span></span>
          </li>
        </ul>
      </div>
      <div class="module module_section2">
        <h3 class="title_com" id="platform">平台特性</h3>
        <p class="subTitle_com">在能源管理应用和能源设备之间搭建高效、稳定、安全的应用平台</p>
        <div class="characteristicCont">
          <div class="item" v-for="(el, ind) in characteristicList" :key="ind">
            <img class="img" :src="el.img" alt="">
            <p class="item_title">{{el.title}}</p>
            <p class="item_subTitle">{{el.subTitle}}</p>
          </div>
        </div>
      </div>

      <div class="module_section3">
        <h3 class="title_com" id="introduction">功能介绍</h3>
        <p class="subTitle_com">定位为提供Paas服务的能源物联网平台，降低新能源企业研发、运营和运维成本，提高新能源/储能项目的落地能力</p>
        <div class="introduce_cont">
          <div class="item" :ref="'item'+ind" v-for="(el, ind) in introduceList" :key="ind">
            <div :class="el.position + ' module'">
              <div 
                :class="el.actived ? 'img fadeInLeft' : 'img'"
                v-if="el.position == 'right'"
                :style="`left:${el.actived ? '0' : pxToRem('-900')}`"
              >
                <img :src="el.img" alt="">
              </div>
              <div 
                :class="el.actived ? 'fadeInText' : ''"
                :style="`opacity:${el.actived ? '1' : '0'}`"
              >
                <p class="title">{{el.title}}</p>
                <ul>
                  <li v-for="(elem, i) in el.list" :key="i">{{elem}}</li>
                </ul>
              </div>
               <div
                :class="el.actived ? 'img fadeInRight' : 'img'" 
                v-if="el.position == 'left'"
                :style="`right:${el.actived ? '0' : pxToRem('-900')}`"
              >
                <img :src="el.img" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="module module_section4">
        <h3 class="title_com" id="case">方案优势</h3>
        <div class="case_cont">
          <div class="item" v-for="(el, ind) in caseList" :key="ind">
            <img :src="el.img" alt="">
            <p class="title">{{el.title}}</p>
            <p class="subTitle">{{el.subTitle}}</p>
          </div>
        </div>
      </div>
      <div class="module_section5">
        <h3 class="title_com title1" id="architecture">部署架构</h3>
        <div class="deploy_cont">
          <div class="module">
            <img class="img" src="https://oss.duodians.com/lambda/office_web/product/product_big_img1.png" alt="">
            <ul class="desc_cont">
              <li>
                <p class="title">
                  <i></i>架构特点
                </p>
                <p class="text">
                  <i></i>
                  <span>IoT Core提供设备接入、双向通信、设备影子、设备检索等功能</span>
                </p>
                <p class="text">
                  <i></i>
                  <span>支持多种数据处理服务，实现多样化数据的处理，并提供多种数据存储服务</span>
                </p>
                <p class="text">
                  <i></i>
                  <span>提供大数据与AI服务，对采集的数据进行存储、管理和分析</span>
                </p>
              </li>
              <li>
                <p class="title"><i></i>方案效果</p>
                <p class="text">
                  <i></i>
                  <span>将IoT设备数据通过协议上传到云端，进行统一处理</span>
                </p>
                <p class="text">
                  <i></i>
                  <span>设备在云端统一管控，实现设备监控、运维、安全认证等全方位管理</span>
                </p>
                <p class="text">
                  <i></i>
                  <span>提供面向行业或者业务的数据分析，例如能源用电分析等</span>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- <div class="module module_section6">
        <h3 class="title_com" id="application">应用场景</h3>
        <div class="scene_cont">
          <ul class="scene_navs">
            <li :class="el.actived ? 'actived' : ''" v-for="(el, ind) in sceneList" :key="ind" @click="handleChangeNav(ind, 'sceneNavs')">{{el.name}}</li>
          </ul>
          <p class="subTitle">{{sceneList[sceneActived].cont}}</p>
          <img :src="sceneList[sceneActived].img" alt="" class="img">
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navs: [{
        id: 1,
        name: '平台特性',
        actived: true,
        href: 'platform'
      }, {
        id: 2,
        name: '功能介绍',
        actived: false,
        href: 'introduction'
      }, {
        id: 3,
        name: '方案优势',
        actived: false,
        href: 'case'
      }, {
        id: 4,
        name: '部署架构',
        actived: false,
        href: 'architecture'
      },
      // {
      //   id: 5,
      //   name: '应用场景',
      //   actived: false,
      //   href: 'application'
      // }
      ],
      characteristicList: [{
        img: 'https://oss.duodians.com/lambda/office_web/product/product_icon1.png',
        title: '响应式',
        subTitle: '支持灵活的数据处理，包含实时计算和批量计算，数据开发更简单'
      }, {
        img: 'https://oss.duodians.com/lambda/office_web/product/product_icon2.png',
        title: '扩展性',
        subTitle: '快速构建能源物联网相关业务系统, 多协议适配，支持多种通信协议，灵活接入不同厂商的不同能源设备'
      }, {
        img: 'https://oss.duodians.com/lambda/office_web/product/product_icon3.png',
        title: '物模型',
        subTitle: '统一的物模型管理，不同设备统一定义统一管理；设备数据收集, 按需求设定数据流转的规则引擎'
      }],
      introduceList: [{
        img: 'https://oss.duodians.com/lambda/office_web/product/product_1.png',
        title: '统一设备管理',
        list: ['统一设备模型，统一管理设备数据', '统一的设备操作API，屏蔽各个厂家不同协议不同设备的差异', '支持跨服务，同步(RRpc)，异步的设备消息收发'],
        position: 'right',
        actived: false
      }, {
        img: 'https://oss.duodians.com/lambda/office_web/product/product_2.png',
        title: '多协议适配, 不同设备使用不同协议接入',
        list: ['集成多种常见的网络协议，实现统一管理、监控、在线调试、在线启动、停止、更新等功能', '多消息协议支持，可在线配置消息解析规则，将自定义的消息解析为平台统一的消息格式'],
        position: 'left',
        actived: false
      },
      {
        img: 'https://oss.duodians.com/lambda/office_web/product/product_3.png',
        title: '可视化配置仪表盘',
        list: ['可配置图表，对接不同数据源，实现折线图，饼状图，地图等数据展示', '定制化生成能源大屏'],
        position: 'right',
        actived: false
      }
      // {
      //   img: 'https://oss.duodians.com/lambda/office_web/product/product_4.png',
      //   title: '生成大屏界面',
      //   list: ['可视化拖拽规则引擎设计器，灵活可拓展的多种规则节点支持', '可通过规则引擎在线动态配置数据，业务处理逻辑。'],
      //   position: 'left',
      //   actived: false
      // }
      ],
      caseList: [{
        title: '支持多种协议',
        subTitle: '支持MQTT、WebSocket、CoAP等多种IOT协议，可适用于多种应用场景',
        img: 'https://oss.duodians.com/lambda/office_web/product/product_icon4.png'
      }, {
        title: '海量数据处理',
        subTitle: '专为IoT场景优化的高性能计算服务、存储服务、负载均衡集群服务，可承载高并发访问和数据传输',
        img: 'https://oss.duodians.com/lambda/office_web/product/product_icon5.png'
      }, {
        title: '开放生态体系',
        subTitle: '开放性体系架构，便于集成第三方合作伙伴的设备、协议、算法，提供能源物联网解决方案',
        img: 'https://oss.duodians.com/lambda/office_web/product/product_icon6.png'
      }, {
        title: '安全访问控制',
        subTitle: '支持多级设备接入和访问认证，严格把控物联网设备身份认证',
        img: 'https://oss.duodians.com/lambda/office_web/product/product_icon7.png'
      }],
      sceneList: [{
        name: '高并发业务场景',
        actived: true,
        cont: '提供多样的数据存储服务，包括文件存储、对象存储等，实现数据的灵活存储、备份和归档',
        img: 'https://oss.duodians.com/lambda/office_web/product/product_big_img2.png'
      }, {
        name: '多样化数据管理',
        actived: false,
        cont: '支持访问日志、业务数据、设备运行日志等多种数据来源的采集',
        img: 'https://oss.duodians.com/lambda/office_web/product/product_big_img3.png'
      }, {
        name: '实时数据流处理',
        actived: false,
        cont: '支持能源设备的实时流数据直接从消息队列传输到Flink计算引擎，可根据期望的时延范围进行处理引擎的灵活选择',
        img: 'https://oss.duodians.com/lambda/office_web/product/product_big_img4.png'
      }],
      sceneActived: 0,
      currentScroll: 0,
    };
  },
  components: {},
  computed: {},
  created() {
      window.addEventListener('scroll', this.handleScrollbox, true)
  },
  methods: {
    handleChangeNav(ind, type, item) {
      if (type == 'navs') {
        this.navs.forEach(el => el.actived = false)
        this.navs[ind].actived = true
        const element = document.getElementById(item.href);
        element.scrollIntoView({block: 'start', behavior: 'smooth'});
      } else if (type == 'sceneNavs') {
        this.sceneList.forEach(el => el.actived = false)
        this.sceneList[ind].actived = true
        this.sceneActived = ind
      }
    },
    handleScrollbox() {
      this.currentScroll = window.pageYOffset //表示当前滚动的位置
      this.introduceList.forEach((el, ind) => {
        if (this.currentScroll >= this.$refs[`item${ind}`][0].offsetTop-400) {
          el.actived = true
        }
      })
    },
    goToLink(url) {
      this.$router.push({ path: url })
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScrollbox, true)
  },
};
</script>
<style lang='less' scoped>
.container{
  position: relative;
  top:-80px;
  z-index: 1;
  margin-bottom: -80px;
  .main{
    .module{
      width:1200px;
      margin: 0 auto;
    }
    .module_section1{
      color: #fff;
      text-align: center;
      height: 600px;
      background: url('https://oss.duodians.com/lambda/office_web/product/product_bg.jpg') no-repeat;
      background-position: center center;
      background-size: 100% 100%;
      .title{
        padding: 170px 0 40px;
        font-size: 48px
      }
      .cont{
        width: 800px;
        margin: 0 auto 42px;
        font-size: 20px;
        line-height: 30px;
        text-align: center;
      }
      .btn{
        width: 148px;
        height: 50px;
        border: 2px solid;
        border-image: linear-gradient(270deg, #4add69 18%, #4cddbd 58%, #3cecf0 43%, #12ee90 99%) 2 2;
        border-radius: 28px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        color: #4cddbd;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        .rightIcon1{
          margin-left: 10px;
        }
      }
    }
    .navs{
      width: 100%;
      height: 50px;
      background: rgba(0,0,0,.3);
      position:sticky;
      z-index: 10;
      top: 0px;
      margin-top: -50px;
      ul{
        display: flex;
        li{
          width: 300px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: #fff;
          cursor: pointer;
        }
        li.actived{
          background: rgba(0,0,0,.6);
          font-weight: 600;
          span{
            display: block;
            width: 20px;
            height: 4px;
            background: #00AB71;
            border-radius: 2px;
            position: absolute;
            bottom: 0;
          }
        }
      }
    }
    .title_com{
      text-align: center;
      height: 54px;
      font-size: 46px;
      font-family: PingFangSC, PingFangSC-Semibold;
      font-weight: 600;
      color: #000000;
      line-height: 54px;
      margin: 99px 0 48px
    }
    .subTitle_com{
      height: 28px;
      text-align: center;
      font-size: 20px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: center;
      color: rgba(0,0,0,.65);
      line-height: 30px;
      margin-top: 30px;
    }
    .module_section2{
      .characteristicCont{
        margin-top: 100px;
        display: flex;
        justify-content: space-between;
        .item{
          width: 356px;
          height: 386px;
          background: #ffffff;
          border: 1px solid #eef2ff;
          border-radius: 0px 28px 28px 28px;
          box-shadow: 10px 10px 40px 10px rgba(131,143,172,0.06); 
          text-align: center;
          cursor: pointer;
          .img{
            width: 100px;
            margin-top: 60px;
          }
          .item_title{
            margin-top: 25px;
            height: 42px;
            font-size: 26px;
            font-family: PingFangSC, PingFangSC-Semibold;
            font-weight: 600;
            text-align: center;
            color: #303132;
            line-height: 42px;
          }
          .item_subTitle{
            width: 280px;
            font-size: 18px;
            font-family: SourceHanSansCN, SourceHanSansCN-Regular;
            font-weight: 400;
            text-align: justify;
            color: rgba(48,49,50, .8);
            line-height: 24px;
            margin: 18px auto;
          }
        }
        .item:hover{
          -webkit-transform: translateY(-8px);
          transform: translateY(-20px);
          -webkit-transition: -webkit-transform .5s;
          transition: -webkit-transform .5s;
          transition: transform .5s;
          transition: transform .5s,-webkit-transform .5s;
        }
      }
    }
    .module_section3{
      padding-top: 100px;
      .introduce_cont{
        overflow: hidden;
        .item{
          margin-top: 100px;
          height: 600px;
          display: flex;
          align-items: center;
          position: relative;
          .title{
            font-size: 34px;
            font-family: SourceHanSansCN, SourceHanSansCN-Bold;
            font-weight: 700;
            text-align: left;
            color: rgba(0,0,0,.85);
            line-height: 51px;
          }
          ul{
            margin-top: 40px;
            li{
              font-size: 18px;
              font-family: SourceHanSansCN, SourceHanSansCN-Medium;
              font-weight: 500;
              color: rgba(48,49,50, .85);
              line-height: 24px;
              margin-bottom: 28px;
              text-align: justify;
            }
            li:before{
              content: '';
              display: inline-block;
              width: 8px;
              height: 8px;
              background: #fff;
              border: 6px solid #06F286;
              border-radius: 50%;
              line-height: 20px;
              margin-right: 10px;
            }
          }
          .left{
            display: flex;
            justify-content: left;
            align-items: center;
            .title{
              width: 510px;
            }
            ul{
              width: 510px;
            }
            .img{
              width: 900px;
              height: 600px;
              background: #f7f8fd;
              border-radius: 300px 0 0 300px;
              position: absolute;
              // right: -900px;
              display: flex;
              align-items: center;
              img{
                width: 520px;
                margin-left: 180px
              }
            }
          }
          .right{
            display: flex;
            justify-content: right;
            align-items: center;
            .title{
              width: 520px;
            }
            ul{
              width: 520px;
            }
            .img{
              width: 900px;
              height: 600px;
              background: #f7f8fd;
              border-radius: 0 300px 300px 0;
              position: absolute;
              // left: -900px;
              display: flex;
              align-items: center;
              justify-content: right;
              img{
                width: 510px;
                margin-right: 220px;
              }
            }
          }
        }
        

      }
    }
    .module_section4{
      padding-top: 100px;
      .case_cont{
        margin-top: 100px;
        display: flex;
        justify-content: space-between;
        .item{
          width: 280px;
          height: 320px;
          background: #f7f8fd;
          border-radius: 0px 24px 24px 24px;
          text-align: center;
          padding: 0 28px;
          cursor: pointer;
          img{
            width: 60px;
            margin: 50px auto 20px;
          }
          .title{
            height: 40px;
            font-size: 26px;
            font-family: PingFangSC, PingFangSC-Semibold;
            font-weight: 600;
            color: rgba(0,0,0,.85);
            line-height: 40px;
          }
          .subTitle{
            margin-top: 18px;
            font-size: 18px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: justify;
            color: rgba(0,0,0,.6);
            line-height: 24px;
          }
        }
        .item:hover{
          -webkit-transform: translateY(-8px);
          transform: translateY(-20px);
          -webkit-transition: -webkit-transform .5s;
          transition: -webkit-transform .5s;
          transition: transform .5s;
          transition: transform .5s,-webkit-transform .5s;
          background: #fff;
          border: 1px solid #eef2ff;
          border-radius: 0px 24px 24px 24px;
          box-shadow: 10px 10px 40px 10px rgba(131,143,172,0.06); 
        }
      }
    }
    .module_section5{
      background: #f6fafd;
      .title1 {
        padding-top: 100px;
      }
      .deploy_cont{
        height: 850px;
        .module{
          .img{
            // height: 400px;
            margin-top: 100px;
            width: 1200px;
          }
          .desc_cont{
            display: flex;
            padding: 70px 30px 0;
            justify-content: space-between;
            li{
              .title{
                i{
                  display: inline-block;
                  width: 0px;
                  height: 0px;
                  border: 6px solid #00AB71;
                  border-color: #00AB71 #00AB71 transparent transparent;
                  margin-right: 12px;
                }
                font-size: 26px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                color: #000000;
                line-height: 37px;
                margin-bottom: 24px;
              }
              .text{
                display: flex;
                align-items:flex-start;
                margin-bottom: 12px;
                i{
                  display: inline-block;
                  width: 6px;
                  height: 6px;
                  background: rgba(30,30,30,.5);
                  margin-right: 13px;
                  border-radius: 50%;
                  margin-top: 10px;
                }
                span{
                  display: inline-block;
                  width:417px;
                  font-size: 18px;
                  font-family: PingFangSC, PingFangSC-Regular;
                  font-weight: 400;
                  text-align: justify;
                  color: rgba(0,0,0,.6);
                  line-height: 26px;
                }
              }
            }
          }
        }
      }
    }
    .module_section6{
      .scene_cont{
        height: 495px;
        background: #f7f8fd;
        text-align: center;
        .scene_navs{
          height: 50px;
          background: #3D3E49;
          display: flex;
          li{
            width: 400px;
            color: rgba(255,255,255,.85);
            font-size: 18px;
            font-family: PingFangSC, PingFangSC-Semibold;
            font-weight: 600;
            background: #3D3E49;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer
          }
          li.actived{
            background: #2ae7a2 linear-gradient(148deg,#4cddbd 13%, #06f286 93%);
            color: rgba(0,0,0,.85);
          }
        }
        .subTitle{
          height: 26px;
          font-size: 16px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          color: rgba(0,0,0,.6);
          line-height: 26px;
          margin: 30px 0 40px;
          text-align: left;
          padding-left: 30px;
        }
        .subTitle::before{
          content: '';
          display: inline-block;
          width: 6px;
          height: 6px;
          background: rgba(30,30,30,.5);
          border-radius: 50%;
          margin-right: 13px;
        }
        .img{
          width: 1140px;
        }
      }
    }
  } 
}
/*从右到左进入*/
.fadeInRight{
  animation-name:fadeInRight;
  animation-duration: 2s;
  animation-iteration-count: 1;
  -webkit-animation:fadeInRight;
  -webkit-animation-duration: 2s;
  -webkit-animation-iteration-count: 1;
}

/*从左到右进入*/
.fadeInLeft{
  animation-name:fadeInLeft;
  animation-duration: 2s;
  animation-iteration-count: 1;
  -webkit-animation:fadeInLeft;
  -webkit-animation-duration: 2s;
  -webkit-animation-iteration-count: 1;
}

// 文字渐显
.fadeInText{
  animation-name:fadeInText;
  animation-duration: 2s;
  animation-iteration-count: 1;
  -webkit-animation:fadeInText;
  -webkit-animation-duration: 2s;
  -webkit-animation-iteration-count: 1;
}

/*从左到右进入*/
@keyframes fadeInLeft{
  from {
    opacity:0;
    -webkit-transform:translate(-900px,0);
    transform:stranslate(-900px,0);
  }to{
    opacity:1;
    -webkit-transform:translate(0px,0);
    transform:stranslate(0px,0);
  }
}

@-webkit-keyframes fadeInLeft{
  from {
    opacity:0;
    -webkit-transform:translate(-900px,0);
    transform:stranslate(-900px,0);
  }to{
    opacity:1;
    -webkit-transform:translate(0px,0);
    transform:stranslate(0px,0);
  }
}

/*从右到左进入*/
@keyframes fadeInRight{
  from {
    opacity:0;
    -webkit-transform:translate(900px,0);
    transform:stranslate(900px,0);
  }to{
    opacity:1;
    -webkit-transform:translate(0px,0);
    transform:stranslate(0px,0);
  }
}

@-webkit-keyframes fadeInRight{
  from {
    opacity:0;
    -webkit-transform:translate(900px,0);
    transform:stranslate(900px,0);
  }to{
    opacity:1;
    -webkit-transform:translate(0px,0);
    transform:stranslate(0px,0);
  }
}

/*文字渐显*/
@keyframes fadeInText{
  from {
    opacity:0;
  }to{
    opacity:1;
  }
}

@-webkit-keyframes fadeInText{
  from {
    opacity:0;
  }to{
    opacity:1;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/product/product.vue